import { getAppApiRoutes } from "../../Global";
import {
  TerminalNeedAddRequestModel,
  TerminalNeedFilterRequestModel,
  TerminalNeedUpdateRequestModel,
} from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiPost, apiPut } from "../apiClient";

class TerminalRequestService {
  async addTerminalRequest(data: TerminalNeedAddRequestModel | Record<string, unknown>): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminalRequest.addTerminalRequest, data as Record<string, unknown>);
  }

  async getTerminalRequests(data: TerminalNeedFilterRequestModel = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.terminalRequest.getTerminalRequests, { orderBy: "createdAt_desc", filter: data });
  }

  async updateTerminalRequest(id: number, data: TerminalNeedUpdateRequestModel = {}): Promise<ResponseModel> {
    return apiPut(getAppApiRoutes.terminalRequest.updateTerminalRequests.replace("{id}", id.toString()), data);
  }
}

const service: TerminalRequestService = new TerminalRequestService();
export default service;
